import React from "react";
import { Col, Row, Select, Upload } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { RELATIONSHIP_OPTIONS } from "../../../../../../constants/common";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

const ParentInformation = ({ fields, control, append }) => (
  <>
    {fields?.map((field, index) => {
      return (
        <div key={field?.id}>
          <Row gutter={[32, 20]}>
            <Col span={12}>
              <Controller
                name={`form4Fields[${index}].full_name`}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomTextfield
                    id="full_name"
                    label="Parent/Guardian Full Name"
                    showRequired
                    labelColor="#171717"
                    placeholder="Enter name"
                    size="large"
                    value={value}
                    onChange={onChange}
                    status={error ? "error" : ""}
                  />
                )}
              />
            </Col>

            <Col span={12}>
              <Controller
                name={`form4Fields[${index}].parent_type`}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomSelect
                    id="parent_type"
                    label="Relationship to Student"
                    showRequired
                    labelColor="#171717"
                    placeholder="--Select--"
                    size="large"
                    value={value}
                    onChange={onChange}
                    status={error ? "error" : ""}
                  >
                    {RELATIONSHIP_OPTIONS.map((item, index) => (
                      <Select.Option key={index} value={item?.value}>
                        {item?.label}
                      </Select.Option>
                    ))}
                  </CustomSelect>
                )}
              />
            </Col>

            <Col span={12}>
              <Controller
                name={`form4Fields[${index}].email`}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomTextfield
                    id="email"
                    label="Email Address"
                    showOptional
                    type="email"
                    labelColor="#171717"
                    placeholder="Enter email"
                    size="large"
                    value={value}
                    prefix={
                      <MailOutlined
                        style={{ color: "#999999", paddingRight: 4 }}
                      />
                    }
                    onChange={onChange}
                    status={error ? "error" : ""}
                  />
                )}
              />
            </Col>

            <Col span={12}>
              <Controller
                name={`form4Fields[${index}].phone_number`}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomTextfield
                    id="phone_number"
                    label="Phone Number"
                    showRequired
                    labelColor="#171717"
                    placeholder="Enter phone number"
                    type="number"
                    size="large"
                    value={value}
                    prefix={
                      <PhoneOutlined
                        style={{ color: "#999999", paddingRight: 4 }}
                      />
                    }
                    onChange={onChange}
                    status={error ? "error" : ""}
                  />
                )}
              />
            </Col>

            <Col span={12}>
              <Controller
                name={`form4Fields[${index}].occupation`}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomTextfield
                    id="occupation"
                    label="Occupation of Parent/Guardian"
                    showOptional
                    labelColor="#171717"
                    placeholder="Enter occupation"
                    size="large"
                    value={value}
                    onChange={onChange}
                    status={error ? "error" : ""}
                  />
                )}
              />
            </Col>

            <Col span={12}>
              <Controller
                name={`form4Fields[${index}].address`}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomTextfield
                    id="address"
                    label="Home Address (if different)"
                    showOptional
                    labelColor="#171717"
                    placeholder="Enter address"
                    size="large"
                    value={value}
                    onChange={onChange}
                    status={error ? "error" : ""}
                  />
                )}
              />
            </Col>
          </Row>

          <div style={{ display: "flex", margin: "20px 0" }}>
            {index === 0 && (
              <div
                onClick={() =>
                  append({
                    id: "",
                    full_name: "",
                    parent_type: "",
                    email: "",
                    phone_number: "",
                    occupation: "",
                    address: "",
                  })
                }
                style={{
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  columnGap: "4px",
                  color: "green",
                  fontWeight: 500,
                  fontSize: "14px",
                  cursor: "pointer",
                  marginLeft: "auto",
                }}
              >
                <img src="/assets/images/addIcon.svg" alt="addIcon" />
                Add Parent/Guardian
              </div>
            )}
          </div>
        </div>
      );
    })}
  </>
);

export default ParentInformation;
